export default __webpack_public_path__ + "media/images/logo-symbol-wordmark-f824615a1062dc0ca2ee0ebb8de16c38.svg";